import { render, staticRenderFns } from "./order.vue?vue&type=template&id=e1228a60&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=e1228a60&prod&scoped=true&lang=css"
import style1 from "./order.vue?vue&type=style&index=1&id=e1228a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1228a60",
  null
  
)

export default component.exports